import React, { useCallback, useEffect } from "react";
import {
  LiquityStoreState,
  Decimal,
  Trove,
  SLSD_LIQUIDATION_RESERVE,
  SLSD_MINIMUM_NET_DEBT,
  Percent
} from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { useAppState } from "../../hooks/AppStateContext";

import {
  selectForTroveChangeValidation,
} from "./validation/validateTroveChange";
import { TroveForm } from "./PSY/TroveForm";

type Props = {
  collateral: Decimal
  setCollateral: React.Dispatch<React.SetStateAction<Decimal>>
  borrowAmount: Decimal
  setBorrowAmount: React.Dispatch<React.SetStateAction<Decimal>>
  originalTrove: Trove
}

const TRANSACTION_ID = "trove-creation";
// const GAS_ROOM_ETH = Decimal.from(0.1);

export const Opening: React.FC<Props> = ({
  collateral,
  setCollateral,
  borrowAmount,
  setBorrowAmount,
  originalTrove,
}) => {
  const { currentCollateralKey } = useAppState();
  const selector = useCallback((state: LiquityStoreState) => {
    if (!currentCollateralKey) {
      return undefined
    }

    const { collateralStates, collateralDerivedStates } = state;
    const { price, allowance, balance } = collateralStates[currentCollateralKey];
    const { fees } = collateralDerivedStates[currentCollateralKey];
    return {
      fees,
      price,
      allowance,
      balance,
      validationContext: selectForTroveChangeValidation(state, currentCollateralKey)
    };
  }, [currentCollateralKey]);

  const selectedState = useLiquitySelector(selector);

  useEffect(() => {
    if (!collateral.isZero && borrowAmount.isZero) {
      setBorrowAmount(SLSD_MINIMUM_NET_DEBT);
    }
  }, [collateral, borrowAmount]); // ___ user has to borrow at least 1800 SLSD

  if (!selectedState) {
    return <></>
  }
  const { fees, balance } = selectedState;
  const borrowingRate = fees.borrowingRate();

  const fee = borrowAmount.mul(borrowingRate);
  const totalDebt = borrowAmount.add(SLSD_LIQUIDATION_RESERVE).add(fee);
  const isDirty = !collateral.isZero || !borrowAmount.isZero;
  const trove = isDirty ? new Trove(collateral, totalDebt) : originalTrove;
  const maxCollateral = balance

  return (
    <TroveForm
      trove={originalTrove}
      updatedTrove={trove}
      maxCollateral={maxCollateral}
      borrowingRate={borrowingRate}
      collateral={collateral}
      setCollateral={setCollateral}
      netDebt={borrowAmount}
      setNetDebt={setBorrowAmount}
      transactionId={TRANSACTION_ID}
      actionLabel="Open Trove"
     />
  );
};
